import React, { useState, useEffect } from "react";
// import PasswordField from "../../components/common/UI/Inputs/Inputs/PasswordInput.jsx";
import { encryptData } from "../../utils/encryptDecrypt";
import useFullPageLoader from "../../hooks/useFullPageLoader";
import { useSelector, useDispatch } from "react-redux";
import "react-datepicker/dist/react-datepicker.css";
import { masterActions, authActions } from "../../_store";
import { registerActions } from "../../_store/userRegister.slice";
import myAccountSchema from "../../validation/myAccountSchema";
import { myAccountActions } from "../../_store/myAccount.slice";
import { useNavigate } from "react-router-dom";
import NotificationService from "../../ui/ui-modal-notification.js";
import "react-toastify/dist/ReactToastify.css";
import { ReactNotifications } from "react-notifications-component";
import Swal from "sweetalert2";
import TextInput from "../../components/common/UI/Inputs/InputControls/TextInput.jsx";
import SelectInput from "../../components/common/UI/Inputs/InputControls/SelectInput.jsx";
import DatePickerComponent from "../../components/common/UI/Inputs/InputControls/DateInput.jsx";
import PasswordField from "../../components/common/UI/Inputs/InputControls/PasswordTextbox.jsx";
import FormatPhoneNumber from "../../components/common/UI/Inputs/InputControls/FormatPhoneNumber.jsx";
import useDraft from "../../components/common/autoSaveDraftMsg/useDraft";
import ConfirmationModal from "../../components/common/UI/Inputs/NotificationModal/BootstrapModalPopup.jsx";
import EmailVerificationModal from "../../components/common/UI/Inputs/NotificationModal/EmailVerificationModal.jsx";
import translations from '../../config/TranslateFile.jsx'
import { EventLog } from "../../components/common/EventLog/EventLog.jsx";
import { storeCurrentRoute } from "../../utils/routeTracker.js";
import useIPAddress from "../../hooks/useIPAddress.jsx";
import useBrowserType from "../../hooks/useBrowserType.jsx";
import { getStoredValue, removeStoredValue } from "../../_helpers/storagehelper.js";


function MyAccount() {
  const [errors, setErrors] = useState({});
  const [stateList, setStateList] = useState([]);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const stateDrpList = useSelector((x) => x.master.stateDrpList);
  const today = new Date();
  const maxDate = new Date(today.setFullYear(today.getFullYear() - 18));
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isInvitedURL] = useState(false);
  // Select LoadPublicUserDetails from the Redux store
  const myAccountDetails = useSelector(
    (state) => state.myAccount.LoadPublicUserDetails
  );
  const userExists = useSelector((state) => state.myAccount.userEmailExists);
  const { registerData } = useSelector(
    (state) => state.register
  );
  const ip = useIPAddress();
  const browser = useBrowserType();
  const currentLang = translations();
  // Used for store inizial state value
  const [initialState, setinitialState] = useState({ email: "", password: "" });
  const [initialSubcribe, setInitialSubcribe] = useState(0);
  const [existUsernameEmail, setExistUsernameEmail] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [modalConfig, setModalConfig] = useState({
    show: false,
    title: "",
    message: "",
    onconfirmname: currentLang?.buttons?.Yes,
    closeButton: true,
    showCancelButton: true,
    onConfirm: () => { },
    onCancel: () => { },
  });

  const [modalEmailVerify, setModalEmailVerify] = useState({
    show: false,
    title: "",
    message: "",
    onNewEmailVerify: () => { },
    onWithoutEmailUpdate: () => { },
  });


  const [accountState, setAccountState] = useState({
    publicUserID: 0,
    firstName: "",
    lastName: "",
    userName: "",
    userPassword: "",
    email: "",
    cellPhone: "",
    address1: "",
    address2: "",
    city: "",
    stateName: "",
    zip: "",
    dob: "",
    gender: "",
    signUpBrowserType: "Chrome",
    signUpIPAddress: "192.67.34.143",
    isSALoginAsPU: 0,
    isSubscribeMail: 0,
    activeStatus: 1,
    action: 2,
    createdBy: 0,
    isAgeVerified: 0,
    iSTeamsConditionVerified: false,
    isRegisteredFromInvite: 0,
    inmateInvitePublicUserID: null,
    userActivate: 1,
    isSucceed: 0,
    inviteGUID: null,
    inviteThrough: null,
    confirmEmail: "",
    confirmPassword: "",
    notificationConditionVerified: false,
    id: 0,
    puPasswordLogID: 0,
  });

  const genderOptions = [
    { value: "1", label: currentLang?.DropDown?.Male },
    { value: "2", label: currentLang?.DropDown?.Female },
  ];

  // Auto Draft save
  const { setIsSaveDraftModified } = useDraft();
  useEffect(() => {
    const savedDraft = getStoredValue("draft");
    if (savedDraft != null) {
      setIsSaveDraftModified(true);
    }
  }, [setIsSaveDraftModified]);

  useEffect(() => {
    if (myAccountDetails && typeof myAccountDetails === "object") {
      setinitialState((prevState) => ({
        ...prevState,
        email: myAccountDetails.Email || prevState.email,
        password: myAccountDetails.UserPassword || prevState.password,
      }));
      setInitialSubcribe(myAccountDetails?.IsSubscribeMail)
      if (myAccountDetails?.DOB === null || myAccountDetails?.DOB === undefined || myAccountDetails?.DOB === "") {
        handleDateChange(myAccountDetails?.DOB === null || myAccountDetails?.DOB === undefined ? null : myAccountDetails?.DOB, "dob")
      }
      setAccountState((prevState) => ({
        ...prevState,
        publicUserID: myAccountDetails.PublicUserID || prevState.publicUserID,
        firstName: myAccountDetails.FirstName || prevState.firstName,
        lastName: myAccountDetails.LastName || prevState.lastName,
        userName: myAccountDetails.UserName || prevState.userName,
        userPassword: myAccountDetails.UserPassword || prevState.userPassword,
        email: myAccountDetails.Email || prevState.email,
        cellPhone: myAccountDetails.CellPhone || prevState.cellPhone,
        address1: myAccountDetails.Address1 || prevState.address1,
        address2: myAccountDetails.Address2 || prevState.address2,
        city: myAccountDetails.City || prevState.city,
        stateName: myAccountDetails.StateNameID || prevState.stateName,
        zip: myAccountDetails.ZIP || prevState.zip,
        dob: myAccountDetails?.DOB === null ? "" : myAccountDetails?.DOB || prevState.dob,
        gender: myAccountDetails.Gender || prevState.gender,
        signUpBrowserType:
          myAccountDetails.SignUpBrowserType || prevState.signUpBrowserType,
        signUpIPAddress:
          myAccountDetails.SignUpIPAddress || prevState.signUpIPAddress,
        isSALoginAsPU:
          myAccountDetails.IsSALoginAsPU || prevState.isSALoginAsPU,
        isSubscribeMail:
          myAccountDetails.IsSubscribeMail || prevState.isSubscribeMail,
        activeStatus: myAccountDetails.ActiveStatus || prevState.activeStatus,
        action: myAccountDetails.Action || prevState.action,
        createdBy: myAccountDetails.CreatedBy || prevState.createdBy,
        isAgeVerified:
          myAccountDetails.ISAgeVerified || prevState.isAgeVerified,
        iSTeamsConditionVerified:
          myAccountDetails.ISTeamsConditionVerified ||
          prevState.iSTeamsConditionVerified,
        isRegisteredFromInvite:
          myAccountDetails.IsRegisteredFromInvite ||
          prevState.isRegisteredFromInvite,
        inmateInvitePublicUserID:
          myAccountDetails.InmateInvitePublicUserID ||
          prevState.inmateInvitePublicUserID,
        userActivate: myAccountDetails.UserActivate || prevState.userActivate,
        isSucceed: myAccountDetails.IsSucceed || prevState.isSucceed,
        inviteGUID: myAccountDetails.InviteGUID || prevState.inviteGUID,
        inviteThrough:
          myAccountDetails.InviteThrough || prevState.inviteThrough,
        confirmEmail: myAccountDetails.Email || prevState.confirmEmail,
        confirmPassword:
          myAccountDetails.UserPassword || prevState.confirmPassword,
        notificationConditionVerified:
          myAccountDetails.NotificationConditionVerified ||
          prevState.notificationConditionVerified,
        id: myAccountDetails.ID || prevState.id,
        puPasswordLogID:
          myAccountDetails.PUPasswordLogID || prevState.puPasswordLogID,
      }));
      setErrors({});
    }
  }, [myAccountDetails]);

  useEffect(() => {
    setAccountState((prev) => ({
      ...prev,
      isSubscribeMail: initialSubcribe, // 0 if checked, 1 if unchecked
    }))
  }, [initialSubcribe])

  useEffect(() => {
    dispatch(myAccountActions.LoadPublicUserDetails());
  }, [dispatch]);

  useEffect(() => {
    if (registerData === 1) {
      setInitialSubcribe(myAccountDetails?.IsSubscribeMail);
      hideLoader();
      dispatch(registerActions.clearRegisterResponse());
      // toast.error(error || "Registration Insert failed.");
      if (accountState.userPassword !== initialState.password) {
        Swal.fire({
          title: currentLang?.Message,
          html: currentLang?.MYAccountPopContent?.Profile_Updated,
          icon: "info",
          width: "500px",
          confirmButtonText: currentLang?.buttons?.OK,
          customClass: {
            confirmButton: "btn btn-success",
          },
          allowOutsideClick: false,
        }).then((result) => {
          if (result.isConfirmed) {
            dispatch(authActions.logout());
          }
        });
      } else {
        setErrors({});
        dispatch(registerActions.clearRegisterResponse());
        NotificationService({
          title: currentLang?.Success,
          message: currentLang?.MYAccountPopContent?.Profile_Updated_Success,
          type: "success", // can be 'success', 'danger', 'info', 'warning'
        });
      }
    } else if (registerData === 3) {
      hideLoader();
      setModalConfig({
        show: true,
        title: "Message",
        message: currentLang?.MYAccountPopContent?.Profile_Updated_Success_Send_Email,
        onConfirm: () => {
          dispatch(authActions.logout());
          navigate("/public/Login");
          storeCurrentRoute("/public/Login");
          setModalConfig((prev) => ({ ...prev, show: false }));
        },
        showCancelButton: false,
        closeButton: false,
        onconfirmname: currentLang?.buttons?.OK,
        onHide: () => setModalConfig((prev) => ({ ...prev, show: false })),
      });
      dispatch(registerActions.clearRegisterResponse());
    } else if (registerData === -2) {
      hideLoader();
      setErrors((prev) => ({
        ...prev,
        email: currentLang?.MYAccountPopContent?.Email_Already_Exists,
      }));
      dispatch(registerActions.clearRegisterResponse());
    } else if (registerData === -3) {
      hideLoader();
      NotificationService({
        title: currentLang?.Warning,
        message: currentLang?.MYAccountPopContent?.UserId_Not_Exists,
        type: "warning", // can be 'success', 'danger', 'info', 'warning'
      });
    } else if (registerData === -5) {
      hideLoader();
      setErrors((prev) => ({
        ...prev,
        userName: currentLang?.MYAccountPopContent?.UserName_Already_Exist,
      }));
      dispatch(registerActions.clearRegisterResponse());
    } else if (registerData === -1) {
      hideLoader();
      NotificationService({
        title: currentLang?.Warning,
        message: currentLang?.MYAccountPopContent?.Registration_Insert_Failed,
        type: "danger", // can be 'success', 'danger', 'info', 'warning'
      });
    }
  }, [registerData]);

  useEffect(() => {
    let stateList = [...stateDrpList];
    setStateList(stateList);
    hideLoader();
  }, [stateDrpList]);

  useEffect(() => {
    showLoader();
    dispatch(masterActions.GetStateList());
  }, [dispatch]);


  useEffect(() => {
    let isMounted = true;

    const fetchData = async () => {
      const ipAddress = ip;
      const browserType = browser;

      // Grouping the state updates to avoid conflicts
      if (isMounted) {
        setAccountState((prevForm) => ({
          ...prevForm,
          IPAddress: ipAddress,
          BrowserType: browserType,
        }));
      }
    };

    fetchData();

    return () => {
      isMounted = false; // cleanup on unmount
    };
  }, [ip, browser]);

  // useEffect(() => {
  //   if (myAccountDetails && myAccountDetails.DOB) {
  //     let date = myAccountDetails.DOB;
  //     const formattedDate = date
  //       // .toLocaleDateString("en-US", {
  //       //   year: "numeric",
  //       //   month: "2-digit",
  //       //   day: "2-digit",
  //       // })
  //       .replace(/\//g, "-"); // Replace slashes with dashes

  //     setDateOfBirth(date);
  //     setAccountState((prev) => ({
  //       ...prev,
  //       dob: formattedDate, // Save the formatted date
  //     }));
  //   }
  // }, [myAccountDetails]);

  useEffect(() => {
    setErrors((prev) => ({
      ...prev,
      email: "",
      userName: "",
    }));
    setErrors({});
  }, [existUsernameEmail])

  // Validation for PublicUserID, UserName, Email already exsists
  useEffect(() => {
    // Handle userExists state for username
    if (userExists !== null && accountState.userName) {
      if (userExists === -3 || userExists === -4) {
        setErrors((prev) => ({
          ...prev,
          userName: currentLang?.MYAccountPopContent?.UserName_Already_Exist,
        }));
      } else {
        setErrors((prev) => ({
          ...prev,
          userName: "", // Clear the error if the username doesn't exist
        }));
      }
    }

    // Handle userExists state for email
    if (userExists !== null && accountState.email) {
      if (userExists === -2 || userExists === -4) {
        setErrors((prev) => ({
          ...prev,
          email: currentLang?.MYAccountPopContent?.Email_Already_Exists,
        }));
      } else if (errors?.email !== currentLang?.ValidationSchema?.Please_enter_valid_email) {
        setErrors((prev) => ({
          ...prev,
          email: "", // Clear the error if the email doesn't exist
        }));
      }
    }
  }, [userExists, accountState.userName, accountState.email]);

  const handleBlur = async (e) => {
    const { name, value } = e.target;

    try {
      // Validate the field using the Joi schema and handle both required and other validation
      await myAccountSchema.validateAsync(
        { [name]: value },
        { abortEarly: false }
      );

      // Clear error if validation passes
      setErrors((prev) => ({
        ...prev,
        [name]: "", // Clear the specific field error
      }));
    } catch (err) {
      // Find the error that matches the current field name
      const fieldError = err.details.find((error) => error.path.includes(name));

      if (fieldError) {
        setErrors((prev) => ({
          ...prev,
          [name]: fieldError.message, // Set the specific field error from Joi
        }));
      }
    }

    // Additional validation for confirmEmail and confirmPassword to check if they match
    if (name === "confirmEmail") {
      if (value !== accountState.email) {
        setErrors((prev) => ({
          ...prev,
          confirmEmail: currentLang?.MYAccountPopContent?.Email_And_ConfirmEmail_MustMatch,
        }));
      } else {
        setErrors((prev) => ({
          ...prev,
          confirmEmail: "", // Clear the error when the emails match
        }));
      }
    }

    if (name === "confirmPassword") {
      if (value !== accountState.userPassword) {
        setErrors((prev) => ({
          ...prev,
          confirmPassword: currentLang?.MYAccountPopContent?.Pwd_And_ConfirmPwd_MustMatch,
        }));
      } else {
        setErrors((prev) => ({
          ...prev,
          confirmPassword: "", // Clear the error when the passwords match
        }));
      }
    }

    // Dispatch an action to check if the username or email exists
    if (name === "userName" || name === "email") {
      PublicUserEmailUsernameExist();
    }
  };

  const PublicUserEmailUsernameExist = async () => {
    await dispatch(
      myAccountActions.PublicUserEmailUsernameExist({
        publicUserID: accountState.publicUserID || "",
        userName: accountState.userName || "",
        email: accountState.email || "",
      })
    );
  }

  const handleSelectChange = (selectedOption, fieldName) => {
    const selectedValue = Array.isArray(selectedOption)
      ? selectedOption.map((option) => option.value) // For multi-select, store an array of values
      : selectedOption?.value ?? ""; // For single-select, store a single value or an empty string

    // Update the accountState with the selected value(s)
    setAccountState((prevState) => ({
      ...prevState,
      [fieldName]: selectedValue, // Store the updated value for the field
    }));

    setErrors((prev) => ({
      ...prev,
      [fieldName]: "", // Clear the specific field error
    }));
  };

  const formatDate = (date) => {
    if (date !== null) {
      const d = new Date(date);
      const month = String(d.getMonth() + 1).padStart(2, '0'); // Get month and pad with leading zero if necessary
      const day = String(d.getDate()).padStart(2, '0'); // Get day and pad with leading zero if necessary
      const year = d.getFullYear(); // Get the full year
      return `${month}/${day}/${year}`; // Return the formatted date
    }
    else {
      return null;
    }
  };

  // Helper function to validate the date
  const isValidDate = (date) => {
    return !isNaN(new Date(date).getTime());
  };

  // Helper function to calculate the valid max date (18 years before current date)
  const getMaxValidDate = () => {
    const today = new Date();
    const maxDate = new Date();
    maxDate.setFullYear(today.getFullYear() - 18); // 18 years before today
    return maxDate;
  };

  const handleDateChange = (date, fieldName) => {
    const maxValidDate = getMaxValidDate();
    const minValidDate = new Date(1900, 0, 1); // January 1st, 1990

    // Ensure the date is valid
    const formattedDate = date && isValidDate(date)
      ? new Intl.DateTimeFormat("en-US", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      }).format(new Date(date))
      : null;

    // Check if the formatted date is within the valid range
    if (formattedDate) {
      const selectedDate = new Date(date);
      if (selectedDate >= minValidDate && selectedDate <= maxValidDate) {
        setAccountState((prevState) => ({
          ...prevState,
          [fieldName]: formatDate(formattedDate), // Update DOB in the parent state
        }));
      } else {
        // If the date is out of range, reset the input or show a message
        setAccountState((prevState) => ({
          ...prevState,
          [fieldName]: null, // Reset date if invalid
        }));
      }
    } else {
      // Reset invalid date
      setAccountState((prevState) => ({
        ...prevState,
        [fieldName]: null,
      }));
    }
  };

  const handleDateBlur = (e, fieldName) => {

    let { value } = e.target;
    const minDate = new Date(1900, 0, 1);
    const maxdate = maxDate;
    const formattedDate = value && isValidDate(value)
      ? new Intl.DateTimeFormat("en-US", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      }).format(new Date(value))
      : null;

    if (new Date(value) >= new Date(minDate) && new Date(value) <= new Date(maxdate)) {
      setAccountState((prevState) => ({
        ...prevState,
        ['dob']: formatDate(formattedDate), // Update DOB in the parent state
      }));
    } else {
      setAccountState((prevState) => ({
        ...prevState,
        ['dob']: null, // Reset date if invalid
      }));
    }

    // const currentDate = accountState[fieldName];
    // if (currentDate && !isValidDate(currentDate)) {
    //   setAccountState((prevState) => ({
    //     ...prevState,
    //     [fieldName]: null,
    //   }));
    // }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    // Define a function to clean values based on field name
    const cleanValue = (name, value) => {
      if (name === "userName") {
        // For userName, remove special characters but allow numbers and letters
        return value.replace(/[^A-Za-z0-9]/g, "");
      }

      if (name === "firstName" || name === "lastName") {
        // For firstName and lastName, remove special characters and numbers
        return value.replace(/[^A-Za-z]/g, "");
      }

      if (name === "zip") {
        // For ZIP code, remove anything that is not a digit or hyphen (limit to 5 digits)
        return value.replace(/[^0-9-]/g, "").slice(0, 5);
      }

      if (name === "cellPhone") {
        // For cellPhone, format input as (999) 999-9999
        const cleanedDigits = value.replace(/\D/g, ""); // Remove non-digit characters
        const length = cleanedDigits.length;

        // Create formatted phone number
        let formattedValue = "";
        if (length > 0) {
          formattedValue += `(${cleanedDigits.substring(0, 3)}`;
        }
        if (length >= 4) {
          formattedValue += `) ${cleanedDigits.substring(3, 6)}`;
        }
        if (length >= 7) {
          formattedValue += `-${cleanedDigits.substring(6, 10)}`;
        }
        return formattedValue; // Return formatted phone number
      }

      // For other fields, return the value as is
      return value;
    };

    // Clean the value based on the field name
    const cleanedValue = cleanValue(name, value);

    // Update the form state with the cleaned value
    setAccountState((prev) => ({
      ...prev,
      [name]: cleanedValue,
    }));

    // Clear error if the user starts typing and an error was previously present
    if (errors[name]) {
      setErrors((prev) => ({
        ...prev,
        [name]: "",
      }));
    }
  };

  const validate = async () => {
    try {
      await myAccountSchema.validateAsync(accountState, { abortEarly: false });
      return {};
    } catch (err) {
      const validationErrors = {};
      err.details.forEach((error) => {
        const field = error.path[0]; // Get the actual field name from the error path
        validationErrors[field] = error.message; // Use the correct field name
      });
      return validationErrors;
    }
  };


  const handleSearch = async (e) => {
    e.preventDefault();

    if ((errors.email !== undefined && errors.email !== "") || (errors.userName !== undefined && errors.userName !== "")) {
      return;
    }
    const validationErrors = await validate();
    setErrors(validationErrors);

    await dispatch(
      myAccountActions.PublicUserEmailUsernameExist({
        publicUserID: accountState.publicUserID || "",
        userName: accountState.userName || "",
        email: accountState.email || "",
      })
    ).then((response) => {
      const IsExistUsernameEmail = response.payload;
      if (Object.keys(validationErrors).length === 0 && IsExistUsernameEmail === 0) {
        const encryptPassword = encryptData(accountState?.userPassword);

        if (initialState.email !== accountState.email) {
          setModalEmailVerify({
            show: true,
            title: currentLang?.Message,
            message: currentLang?.MYAccountPopContent?.Account_Reactivation_Verify_NewMail,
            onNewEmailVerify: () => {
              showLoader();
              const encryptPassword = encryptData(accountState?.userPassword);
              showLoader();
              dispatch(
                registerActions.registerUser({
                  formData: {
                    ...accountState,
                    userPassword: encryptPassword,
                    userActivate: 0, // Set User Inactivate
                  },
                  isInvitedURL,
                })
              );
              removeStoredValue("userID")
            },
            onWithoutEmailUpdate: () => {
              const encryptPassword = encryptData(accountState?.userPassword);
              showLoader();
              dispatch(
                registerActions.registerUser({
                  formData: {
                    ...accountState,
                    email: initialState.email,
                    userPassword: encryptPassword,
                    userActivate: 1, // Set User activate
                  },
                  isInvitedURL,
                })
              );
              setAccountState((prevState) => ({
                ...prevState,
                email: initialState.email,
                confirmEmail: initialState.email,
              }));
              hideLoader();
            }
          });
        } else if (initialState.userPassword !== accountState.userPassword) {
          setModalConfig({
            show: true,
            title: currentLang?.Message,
            message: currentLang?.MYAccountPopContent?.Profile_Update_Confirmation,
            onConfirm: () => {
              showLoader();
              dispatch(
                registerActions.registerUser({
                  formData: { ...accountState, userPassword: encryptPassword },
                  isInvitedURL,
                })
              );
              const infoMessage = "My Account - Profile Data's Update Confirmation PopUp - Clicked Yes";
              const redirectURL = "---";
              const Response = "CHANGE PASSWORD";
              const Status = "Hided confirmation popup";
              EventLog(dispatch, infoMessage, redirectURL, Response, Status)
            },
            onCancel: () => {
              const infoMessage = "My Account - Profile Data's Update Confirmation PopUp Clicked No";
              const redirectURL = "---";
              const Response = "---";
              const Status = "Hided confirmation popup";
              EventLog(dispatch, infoMessage, redirectURL, Response, Status)
            }
          });
        } else {
          setModalConfig({
            show: true,
            title: currentLang?.Message,
            message: currentLang?.MYAccountPopContent?.Profile_Update_Confirmation,
            onConfirm: () => {
              showLoader();
              dispatch(
                registerActions.registerUser({
                  formData: { ...accountState, userPassword: encryptPassword },
                  isInvitedURL,
                })
              );
              const infoMessage = "My Account - Profile Data's Update Confirmation PopUp - Clicked Yes";
              const redirectURL = "---";
              const Response = "---";
              const Status = "Hided confirmation popup";
              EventLog(dispatch, infoMessage, redirectURL, Response, Status)
            },
            onCancel: () => {
              const infoMessage = "My Account - Profile Data's Update Confirmation PopUp Clicked No";
              const redirectURL = "---";
              const Response = "---";
              const Status = "Hided confirmation popup";
              EventLog(dispatch, infoMessage, redirectURL, Response, Status)
            }
          });
        }
      }
    })
  };


  const handleReset = async (e) => {
    e.preventDefault();
    await dispatch(myAccountActions.clearuserEmailExistsResponse());
    showLoader();
    await dispatch(myAccountActions.LoadPublicUserDetails());
    setAccountState((prev) => ({
      ...prev,
      isSubscribeMail: initialSubcribe, // 1 if checked, 0 if unchecked
    }))
    setExistUsernameEmail(true);
    setErrors({});
    hideLoader();
    setShowPassword(false);
    setShowConfirmPassword(false);
    const infoMessage = "My Account - Clear Input Fileds";
    const redirectURL = "public/MyAccount";
    const Response = "---";
    const Status = "---";
    EventLog(dispatch, infoMessage, redirectURL, Response, Status)
  };

  const handleCancelMyAccount = (e) => {
    e.preventDefault();
    const infoMessage = "My Account - Click Cancel My Account button";
    const redirectURL = "---";
    const Response = "Shows YES or NO popup to confirm the action";
    const Status = "---";
    EventLog(dispatch, infoMessage, redirectURL, Response, Status)
    setModalConfig({
      show: true,
      title: currentLang?.MYAccountPopContent?.Deactivate_Account,
      message: currentLang?.MYAccountPopContent?.Deactivate_Account_Content,
      onConfirm: () => {
        EventLog(dispatch, infoMessage, redirectURL, Response, Status)
        dispatch(
          myAccountActions.PublicUserCancelMyAccount({
            publicUserID: accountState.publicUserID,
          })
        ).then((response) => {
          const infoMessage = "Public User - Cancel My Account";
          const redirectURL = "/public/Login";
          const Response = response?.payload;
          const Status = "Cancelled Public User Account";
          EventLog(dispatch, infoMessage, redirectURL, Response, Status)
        });

        dispatch(authActions.logout());
        // navigate("/public/Login");

        navigate("/public/Login", {
          state: {
            username: accountState?.userName,
            password: accountState?.userPassword,
          },
        });
        storeCurrentRoute("/public/Login");
        setModalConfig((prev) => ({ ...prev, show: false }));
      },
      onCancel: () => {
        const infoMessage = "My Account - Clicked No Option from Cancel My Account confirmation Popup";
        const redirectURL = " --- ";
        const Response = " --- ";
        const Status = "Hided confirmation popup";
        EventLog(dispatch, infoMessage, redirectURL, Response, Status)
      },
      onHide: () => {
        setModalConfig((prev) => ({ ...prev, show: false }))
        const infoMessage = "My Account - Clicked No Option from Cancel My Account confirmation Popup";
        const redirectURL = " --- ";
        const Response = " --- ";
        const Status = "Hided confirmation popup";
        EventLog(dispatch, infoMessage, redirectURL, Response, Status)
      },
    });
  };


  return (
    <>
      <ConfirmationModal
        show={modalConfig.show}
        title={modalConfig.title}
        message={modalConfig.message}
        onConfirm={() => {
          modalConfig.onConfirm();
          setModalConfig((prev) => ({ ...prev, show: false }));
        }}
        onconfirmname={modalConfig.onconfirmname || currentLang?.buttons?.Yes}
        closeButton={modalConfig.closeButton}
        showCancelButton={modalConfig.showCancelButton}
        onHide={() => {
          modalConfig.onCancel && modalConfig.onCancel();
          setModalConfig((prev) => ({ ...prev, show: false }))
        }}
        oncancelname={currentLang?.buttons?.No}
      />
      <EmailVerificationModal
        show={modalEmailVerify.show}
        title={modalEmailVerify.title}
        message={modalEmailVerify.message}
        onNewEmailVerify={() => {
          modalEmailVerify.onNewEmailVerify();
          setModalEmailVerify((prev) => ({ ...prev, show: false }));
          const infoMessage = "My Account - Profile Data's Update With Email Change Confirmation Popup - Clicked Email With Verify Option";
          const redirectURL = " --- ";
          const Response = " --- ";
          const Status = "Hided confirmation popup";
          EventLog(dispatch, infoMessage, redirectURL, Response, Status)
        }}
        onWithoutEmailUpdate={() => {
          modalEmailVerify.onWithoutEmailUpdate();
          setModalEmailVerify((prev) => ({ ...prev, show: false }));
          const infoMessage = "My Account - Profile Data's Update With Email Change Confirmation Popup - Clicked Update Others Except Email Option";
          const redirectURL = " --- ";
          const Response = " --- ";
          const Status = "Hided confirmation popup";
          EventLog(dispatch, infoMessage, redirectURL, Response, Status)
        }}
        onHide={() => {
          const infoMessage = "My Account - Profile Data's Update With Email Change Confirmation Popup - Clicked Cancel Option";
          const redirectURL = " --- ";
          const Response = " --- ";
          const Status = "Hided confirmation popup";
          EventLog(dispatch, infoMessage, redirectURL, Response, Status)
          setModalEmailVerify((prev) => ({ ...prev, show: false }))
        }}
      />

      <ReactNotifications />
      <div className="">
        <div>
          <div className="header-title">
            <h5>
              {/* <i className="fa fa-user me-2"></i> */}
              {currentLang?.MyAccount}
            </h5>
          </div>
        </div>
        <div className="h-100 d-flex justify-content-center align-items-center">
          <div className="card w-100 border-radius-all shadow-sm mb-5">
            <div className="card-body p-4">
              <form onSubmit={handleSearch}>
                <div className="row">
                  <div className="col-12 col-md-6 col-lg-4 mb-2">
                    <TextInput
                      name="lastName"
                      id="lastName"
                      label={currentLang?.MyAccountPage?.Last_Name}
                      value={accountState.lastName}
                      handleChange={handleChange}
                      handleBlur={handleBlur}
                      placeholder={currentLang?.MyAccountPage?.Last_Name}
                      required={true}
                      errorMessage={errors.lastName}
                      maxLength={50}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          e.preventDefault();
                          handleSearch(e);
                        }
                      }}
                    />
                  </div>
                  <div className="col-12 col-md-6 col-lg-4 mb-2">
                    <TextInput
                      name="firstName"
                      id="firstName"
                      label={currentLang?.MyAccountPage?.First_Name}
                      value={accountState.firstName}
                      handleChange={handleChange}
                      handleBlur={handleBlur}
                      placeholder={currentLang?.MyAccountPage?.First_Name}
                      required={true}
                      errorMessage={errors.firstName}
                      maxLength={50}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          e.preventDefault();
                          handleSearch(e);
                        }
                      }}
                    />
                  </div>
                  <div className="col-12 col-md-6 col-lg-4 mb-2">
                    <TextInput
                      name="userName"
                      id="userName"
                      label={currentLang?.MyAccountPage?.Username}
                      value={accountState.userName}
                      handleChange={handleChange}
                      handleBlur={handleBlur}
                      placeholder={currentLang?.MyAccountPage?.Username}
                      required={true}
                      errorMessage={errors.userName}
                      maxLength={50}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          e.preventDefault();
                          handleSearch(e);
                        }
                      }}
                    />
                  </div>

                  <div className="col-12 col-md-6 col-lg-4 mb-2">
                    <SelectInput
                      options={genderOptions}
                      value={accountState.gender}
                      onChange={(selectedOption) =>
                        handleSelectChange(selectedOption, "gender")
                      }
                      name="gender" // Make sure the name is passed
                      labelKey="label"
                      valueKey="value"
                      isClearable={true}
                      placeholder={currentLang?.MyAccountPage?.Select_Gender}
                      label={currentLang?.MyAccountPage?.Gender}
                      required={true}
                      handleBlur={handleBlur} // This will now work like with your TextInput
                      errorMessage={errors.gender} // Make sure this is correctly passed
                    />
                  </div>

                  <div className="col-12 col-md-6 col-lg-4 mb-2">
                    <TextInput
                      name="email"
                      id="email"
                      label={currentLang?.MyAccountPage?.E_mail}
                      value={accountState.email}
                      handleChange={handleChange}
                      handleBlur={handleBlur}
                      placeholder={currentLang?.MyAccountPage?.E_mail}
                      required={true}
                      errorMessage={errors.email}
                      maxLength={64}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          e.preventDefault();
                          handleSearch(e);
                        }
                      }}
                    />
                  </div>

                  <div className="col-12 col-md-6 col-lg-4 mb-2">
                    <TextInput
                      name="confirmEmail"
                      id="confirmEmail"
                      label={currentLang?.MyAccountPage?.Confirm_Email}
                      value={accountState.confirmEmail}
                      handleChange={handleChange}
                      handleBlur={handleBlur}
                      placeholder={currentLang?.MyAccountPage?.Confirm_Email}
                      required={true}
                      errorMessage={errors.confirmEmail}
                      maxLength={64}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          e.preventDefault();
                          handleSearch(e);
                        }
                      }}
                    />
                  </div>

                  <div className="col-12 col-md-6 col-lg-4 mb-2">
                    <PasswordField
                      name="userPassword"
                      id="userPassword" // Ensure the id matches
                      label={currentLang?.MyAccountPage?.Password}
                      placeholder={currentLang?.MyAccountPage?.Password}
                      value={accountState.userPassword}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      errorMessage={errors.userPassword} // Use errorMessage prop
                      required // Mark as required if necessary
                      maxLength={50}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          e.preventDefault();
                          handleSearch(e);
                        }
                      }}
                      showPassword={showPassword}
                      setShowPassword={setShowPassword}
                    />
                  </div>
                  <div className="col-12 col-md-6 col-lg-4 mb-2">
                    <PasswordField
                      name="confirmPassword"
                      id="userPassword" // Ensure the id matches
                      label={currentLang?.MyAccountPage?.Confirm_Password}
                      placeholder={currentLang?.MyAccountPage?.Confirm_Password}
                      value={accountState.confirmPassword}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      errorMessage={errors.confirmPassword} // Use errorMessage prop
                      required // Mark as required if necessary
                      maxLength={50}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          e.preventDefault();
                          handleSearch(e);
                        }
                      }}
                      showPassword={showConfirmPassword}
                      setShowPassword={setShowConfirmPassword}
                    />
                  </div>
                  <div className="col-12 col-md-6 col-lg-4 mb-2">
                    <DatePickerComponent
                      value={accountState.dob}
                      onChange={(date) => handleDateChange(date, "dob")}
                      name="dob"
                      label={currentLang?.MyAccountPage?.DOB}
                      minDate={new Date(1900, 0, 1)}
                      maxDate={maxDate}
                      required={false}
                      disabled={false}
                      yearDropDown={true}
                      monthDropDown={true}
                      onBlur={(e) => { handleDateBlur(e, "dob") }}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          e.preventDefault();
                          handleSearch(e);
                        }
                      }}
                    />
                  </div>

                  <div className="col-12 col-md-6 col-lg-4 mb-2">
                    <FormatPhoneNumber
                      name="cellPhone"
                      value={accountState.cellPhone}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={errors.cellPhone} // Pass error message as needed
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          e.preventDefault();
                          handleSearch(e);
                        }
                      }}
                    />
                  </div>

                  <div className="col-12 col-md-6 col-lg-4 mb-2">
                    <TextInput
                      name="address1"
                      id="address1"
                      label={currentLang?.MyAccountPage?.Address1}
                      value={accountState.address1}
                      handleChange={handleChange}
                      handleBlur={handleBlur}
                      placeholder={currentLang?.MyAccountPage?.Address1}
                      required={true}
                      errorMessage={errors.address1}
                      maxLength={50}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          e.preventDefault();
                          handleSearch(e);
                        }
                      }}
                    />
                  </div>

                  <div className="col-12 col-md-6 col-lg-4 mb-2">
                    <TextInput
                      name="address2"
                      id="address2"
                      label={currentLang?.MyAccountPage?.Address2}
                      value={accountState.address2}
                      handleChange={handleChange}
                      handleBlur={handleBlur}
                      placeholder={currentLang?.MyAccountPage?.Address2}
                      required={false}
                      errorMessage={errors.address2}
                      maxLength={50}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          e.preventDefault();
                          handleSearch(e);
                        }
                      }}
                    />
                  </div>

                  <div className="col-12 col-md-6 col-lg-4 mb-2">
                    <TextInput
                      name="city"
                      id="city"
                      label={currentLang?.MyAccountPage?.City}
                      value={accountState.city}
                      handleChange={handleChange}
                      handleBlur={handleBlur}
                      placeholder={currentLang?.MyAccountPage?.City}
                      required={true}
                      errorMessage={errors.city}
                      maxLength={50}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          e.preventDefault();
                          handleSearch(e);
                        }
                      }}
                    />
                  </div>

                  <div className="col-12 col-md-6 col-lg-4 mb-2">
                    <SelectInput
                      options={stateList}
                      value={accountState.stateName} // Ensure this reflects the selected state
                      onChange={(selectedOption) =>
                        handleSelectChange(selectedOption, "stateName")
                      }
                      name="stateName" // Make sure the name is passed correctly
                      labelKey="label" // Key for the label in options
                      valueKey="value" // Key for the value in options
                      isMulti={false} // Specify that multiple selections are not allowed
                      closeMenuOnSelect={true} // Close menu after selecting an option
                      isDisabled={false} // Enable the selection
                      isClearable={true} // Allow clearing the selection
                      placeholder={currentLang?.MyAccountPage?.Select_State} // Placeholder text
                      label={currentLang?.MyAccountPage?.State} // Label for the select input
                      required={true} // Indicate that this field is required
                      handleBlur={handleBlur} // Handle blur event
                      errorMessage={errors.stateName} // Display errors if any
                    />
                  </div>

                  <div className="col-12 col-md-6 col-lg-4 mb-2">
                    <TextInput
                      name="zip"
                      id="zip"
                      label={currentLang?.MyAccountPage?.ZIP}
                      value={accountState.zip}
                      handleChange={handleChange}
                      handleBlur={handleBlur}
                      placeholder={currentLang?.MyAccountPage?.ZIP}
                      required={true}
                      errorMessage={errors.zip}
                      maxLength={5}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          e.preventDefault();
                          handleSearch(e);
                        }
                      }}
                    />
                  </div>

                  <div>
                    <div className="form-check mb-4">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        name="isAgeVerified"
                        id="unSubscribeCheckbox"
                        checked={accountState?.isSubscribeMail === 0} // Ensure it's checked if value is 1
                        onChange={(e) =>
                          setAccountState((prev) => ({
                            ...prev,
                            isSubscribeMail: e.target.checked ? 0 : 1, // 1 if checked, 0 if unchecked
                          }))
                        }
                      />
                      <label
                        className="form-check-label"
                        htmlFor="unSubscribeCheckbox"
                      >
                        {currentLang?.MyAccountPage?.Unsubscribe}
                      </label>
                      {errors.isSubscribeMail && (
                        <p className="text-danger">{errors.isSubscribeMail}</p>
                      )}
                    </div>
                  </div>
                </div>


                <div className="d-flex justify-content-start flex-wrap mt-1">
                  <button type="submit" className="btn btn-success me-2 font-size-14 mb-2">
                    <i className="fa-solid fa-pen-to-square me-1"></i>
                    {currentLang?.buttons?.Update}
                  </button>
                  <button
                    type="button"
                    className="btn btn-grey me-2 mb-2 font-size-14"
                    onClick={handleReset}
                  >
                    <i className="fa-solid fa-arrow-rotate-left me-1"></i>
                    {currentLang?.buttons?.Reset}
                  </button>

                  <button
                    type="button"
                    className="btn btn-danger mb-2 font-size-14"
                    onClick={handleCancelMyAccount}
                  >
                    <i className="fa-solid fa-xmark me-1"></i>
                    {currentLang?.buttons?.Cancel_My_Account}
                  </button>
                </div>
              </form>
            </div>
          </div>

        </div>
      </div>
      {loader}
    </>
  );
}

export default React.memo(MyAccount);
